import * as actionTypes from "./actionTypes";

export const getCompleteAuditTrails = (payload) => ({
  type: `${actionTypes.GET_COMPLETE_EMS_TRAIL}_INITIAL`,
  payload,
});

export const getCompleteAuditTrailFailed = (payload) => ({
  type: `${actionTypes.GET_COMPLETE_EMS_TRAIL}_FAILED`,
  payload,
});
export const getCompleteAuditTrailSuccess = (payload, isFrom) => ({
  type: `${actionTypes.GET_COMPLETE_EMS_TRAIL}_SUCCESS`,
  payload,
  isFrom,
});
export const generateCompleteAuditTrail = (payload) => ({
  type: actionTypes.GENERATE_COMPLETE_EMS_TRAIL,
  payload,
});
export const generateCompleteAuditTrailFailed = (payload) => ({
  type: `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_FAILED`,
  payload,
});
export const generateCompleteAuditTrailSuccess = (payload) => ({
  type: `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_SUCCESS`,
  payload,
});
export const statusCompleteAuditTrail = (payload) => ({
  type: `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_STATUS`,
  payload,
});
export const cancelCompleteAuditTrail = (payload, isStatus) => ({
  type: `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_CANCEL`,
  payload,
  isStatus,
});
export const downloadCompleteAuditTrail = (payload) => ({
  type: actionTypes.DOWNLOAD_COMPLETE_EMS_TRAIL,
  payload,
});
export const downloadCompleteAuditTrailFailed = (payload, id) => ({
  type: `${actionTypes.DOWNLOAD_COMPLETE_EMS_TRAIL}_FAILED`,
  payload,
  id,
});
export const downloadCompleteAuditTrailSuccess = (payload) => ({
  type: `${actionTypes.DOWNLOAD_COMPLETE_EMS_TRAIL}_SUCCESS`,
  payload,
});
export const cancelCompleteAuditTrailBeforeSuccess = (payload) => ({
  type: `${actionTypes.GENERATE_COMPLETE_EMS_TRAIL}_CANCEL_BEFORE_SUCCESS`,
  payload,
});
export const setInitialArchiveCancel = (payload) => ({
  type: actionTypes.SET_INITIAL_ARCHIVE_CANCEL,
  payload
})
